import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Text} from '@chakra-ui/react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

export const getLowStockWarning = (productData) => {
    const configs = getConfig()
    const inventory = productData?.inventory?.ats
    const threshold =
        productData?.c_lowStockThreshold ??
        parseInt(configs.app.library.globalLowstockThreshold || '100')

    if (inventory && inventory < threshold) {
        return (
            <Text fontSize="sm" fontWeight="semibold">
                <FormattedMessage
                    defaultMessage="Last chance - only a few left"
                    id="global_lowStockThresholdGlobal_message"
                />
            </Text>
        )
    }

    return <></>
}
